import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getDenominationSummary = ({
  startDate,
  endDate,
  denominationId
}) => {
  return axios.get(
    `/denominations/${denominationId}/summary?start_date=${startDate}&end_date=${endDate}`
  );
};

export const useDenominationSummary = ({
  startDate,
  endDate,
  denominationId,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["denomination-summary", startDate, endDate, denominationId],
    queryFn: () =>
      getDenominationSummary({ startDate, endDate, denominationId }),
    enabled: !!denominationId,
    select: data => data.result
  });
};
